module.exports = __webpack_public_path__ + "img/inter27.71b1a204.jpg";